/** 顶部导航主题：light / deep，资源位于 /public/new-ui */
export const UI_THEME_STORAGE_KEY = 'uiTheme'
export const UI_THEMES = ['light', 'deep']
export const DEFAULT_UI_THEME = 'deep'

const ASSETS = {
    light: {
        logo: '/new-ui/logo_light_new.png',
        menu: '/new-ui/background_light.png',
        right: '/new-ui/right_light.png',
        screen: '/new-ui/screen_light.png',
        map: '/new-ui/map_light.png',
        activeBg: '/new-ui/active_bg_light.png',
    },
    deep: {
        logo: '/new-ui/logo_deep_new.png',
        menu: '/new-ui/background_deep.png',
        right: '/new-ui/right_deep.png',
        screen: '/new-ui/screen_deep.png',
        map: '/new-ui/map_deep.png',
        activeBg: '/new-ui/active_bg_deep.png',
    },
}

export function isValidTheme(theme) {
    return UI_THEMES.indexOf(theme) >= 0
}

export function getStoredTheme() {
    try {
        const theme = localStorage.getItem(UI_THEME_STORAGE_KEY)
        return isValidTheme(theme) ? theme : DEFAULT_UI_THEME
    } catch (e) {
        return DEFAULT_UI_THEME
    }
}

export function setStoredTheme(theme) {
    if (!isValidTheme(theme)) return
    localStorage.setItem(UI_THEME_STORAGE_KEY, theme)
}

export function getThemeAssets(theme) {
    return ASSETS[isValidTheme(theme) ? theme : DEFAULT_UI_THEME]
}

export function getNextTheme(theme) {
    const current = isValidTheme(theme) ? theme : DEFAULT_UI_THEME
    return current === 'light' ? 'deep' : 'light'
}

export function getThemeLabel(theme) {
    return theme === 'light' ? '浅色主题' : '深色主题'
}
